import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from 'types/store';
import { getText } from 'utils/getText';

import { toggle as toggleAction } from '../store/modules/language/actions';

const mapStateToProps = (state: RootState) => ({
  getText: (text: any) =>
    getText(text, state.language.primary ? 'primary' : 'secondary'),
  primary: state.language.primary
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      toggle: toggleAction
    },
    dispatch
  );

interface ILanguageState {
  primary: boolean;
  getText: (text: any) => string;
}

interface ILanguageDispatch {
  toggle: (open: boolean) => void;
}

export type WithLanguageProps = ILanguageDispatch & ILanguageState;

const withLanguageState = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withLanguageState;



// WEBPACK FOOTER //
// ./src/enhancers/withLanguageState.tsx